import {useEffect, useRef, useState} from "react";

export const useBlockHeightObserver = () => {
  const ref = useRef()
  const [height, setHeight] = useState(0)

  useEffect(() => {
    const observer = new ResizeObserver((entries) => {
      const nextHeight = entries[0].contentRect.height;
      if (height !== nextHeight) setHeight(nextHeight);
    })
    observer.observe(ref.current)
    return () => ref.current && observer.unobserve(ref.current)
  }, []);

  return {ref, height};
}
